module.exports = __webpack_public_path__ + "static/media/image-5.64cf18b3.jpeg";